import React, {useEffect, useState} from 'react';
import './superxProjectDetail.css'
import C2wSuperxProjectDescCard from '../../../common/C2wSuperxHome/pages/superxProjectDetail/superxProjectDescCard';
import C2wGridImageView from '../../../common/C2wSuperxHome/pages/superxProjectDetail/gridImageView';
import { useLocation, useParams } from 'react-router';

function C2wSuperxProjectDetail() {

  const { state } = useLocation();
  const data = state?.superxData;

  return (
    <div className='C2wSuperxProjectDetail_ctn'>
      <div className='C2wSuperxProjectDetail_ctn_scroller'>
        <C2wSuperxProjectDescCard 
          prjDescData={data}
        />
        <div className='C2wSuperxProjectDetail_ctn_h2'>
          <h2>{'Project Photos'}</h2>
        </div>
        <div className='test'>
        <div className='Superx_Project_GridView'>
          {/* {data?.gallery?.map((src) => (
              <img className='superproject-grid-img' src={`/assets/superx/images/projectWisePhotos/${src}`} alt={`${src}-img`} />
          ))} */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default C2wSuperxProjectDetail
